module.exports = __webpack_public_path__ + "static/media/Moldflow Insight Standard.320cd141.png";